export const displayCriteriaFields = {
  orderNetValue: 'order_net_value',
  shipmentWeight: 'shipment_weight',
}

export const criteriaMatchTypes = {
  greaterThan: 'greater_than',
  greaterThanOrEqual: 'greater_than_or_equal',
  lowerThan: 'lower_than',
  lowerThanOrEqual: 'lower_than_or_equal',
  valueInRange: 'value_in_range',
}

export const singleValueRangePrefixes = {
  [criteriaMatchTypes.greaterThan]: '>',
  [criteriaMatchTypes.greaterThanOrEqual]: '≥',
  [criteriaMatchTypes.lowerThan]: '<',
  [criteriaMatchTypes.lowerThanOrEqual]: '≤',
}
